import '~/entrypoints/application.css'

import * as Turbo from '@hotwired/turbo'
Turbo.start()

// <turbo-stream action="visit" target="/caminho"> navega a página inteira (polling do Pix).
Turbo.StreamActions.visit = function () {
  Turbo.visit(this.getAttribute('target'))
}

import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()
const controllers = import.meta.glob('~/controllers/**/*_controller.js', { eager: true })
registerControllers(application, controllers)
